export function getZipCodeBase(zipCode = '') {
    return zipCode ? zipCode.substring(0, 5) : null;
}
